module.exports = __webpack_public_path__ + "img/EE12001988.1f3f612d.png";